<p-table [value]="allPurchaseTemplates">
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Created By</th>
        <th>Last Modified</th>
        <th>Is Active</th>
        <th>Action</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-template let-i="rowIndex">
      <tr>
        <td>{{template.templateName}}</td>
        <td>{{template.createdUser}}</td>
        <td>{{template.updatedDate | date: 'MM/dd/yyyy'}}</td>
        <td>{{template.isActive?answertypeConstants.Yes:answertypeConstants.No}}</td>
        <td class="action">
          <span class="btnBars p-mr-0" (click)="showEditPOTemplate(template)" pTooltip="Edit"
            tooltipPosition="top"><i class="pi pi-pencil"></i></span>
        </td>
      </tr>
    </ng-template>
  </p-table>

<!-- purchase order -->
<p-dialog header="Template - {{purchaseTemplateDialogHeader}}" [(visible)]="displayEditPOTemplate1" [modal]="true" 
  [responsive]="true" [style]="{width: '60em'}" (onHide)="hideDialog()">
  <div class="card">
    <div class="p-grid">
      <div class="p-col-4 p-pr-0">
        <h6 class="p-mb-0">Label Name</h6>
      </div>
      <div class="p-col-5 p-pl-0">
          <h6 class="p-col p-ml-2 p-mb-0">Edit Label Name</h6>
      </div>
      <div class="p-col p-mb-0 p-text-center">
        <h6>Show/Hide</h6>
      </div>
      <div class="p-col p-mb-0" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Bill Payment'
      ||  templatePOTemp?.producttype?.name=='Vendor Returns' || templatePOTemp?.producttype?.name=='Bill' || templatePOTemp?.producttype?.name=='Vendor Credit'">
        <h6>Print/Email</h6>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_billing.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_billing" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[0] && purchaseOrderSections[0].name}}</h5>
                <h5 *ngIf="vendorSections.length>0">{{vendorSections[0] && vendorSections[0].name}}</h5>
                <h5 *ngIf="itemReceiptSections.length>0">{{itemReceiptSections[0] && itemReceiptSections[0].name}}</h5>
                <h5 *ngIf="newBillSections.length>0">{{newBillSections[0] && newBillSections[0].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[0] && vendorReturnSections[0].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections?.length > 0">{{vendorCreditSections[0] && vendorCreditSections[0]?.name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox #l1 ngDefaultControl  (click)="selectedPurchaseRow1(selectedPurchaseCheck1,'view')"
                [(ngModel)]="selectedPurchaseCheck1" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
                *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill Payment' ||  templatePOTemp?.producttype?.name=='Bill' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox #l1 ngDefaultControl (click)="selectedPurchaseRow1(selectedPurchasePrintCheck1,'print')"
                [(ngModel)]="selectedPurchasePrintCheck1" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr *ngIf="!label.IsHide">
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setBillingSection(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order'||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.IsPrint"
                binary="true" (click)="setBillingSection(label.IsPrint,'print')"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_shipping.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_shipping" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5  *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[1] && purchaseOrderSections[1].name}}</h5>
                <h5 *ngIf="vendorSections.length>0">{{vendorSections[3] && vendorSections[3].name}}</h5>
                <h5 *ngIf="itemReceiptSections.length>0">{{itemReceiptSections[1] && itemReceiptSections[1].name}}</h5>
                <h5 *ngIf="newBillSections.length>0">{{newBillSections[1] && newBillSections[1].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[1] && vendorReturnSections[1].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[1] && vendorCreditSections[1].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox  #l2 ngDefaultControl (click)="selectedPurchaseRow2(selectedPurchaseCheck2,'view')"
                [(ngModel)]="selectedPurchaseCheck2" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
                *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox  #l2 ngDefaultControl (click)="selectedPurchaseRow2(selectedPurchasePrintCheck2,'print')"
                [(ngModel)]="selectedPurchasePrintCheck2" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr *ngIf="!label.IsHide">
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="!label.isMovable" [value]="label" [(ngModel)]="label.isChecked"
                (click)="setShippingSection(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="!label.isMovable" [value]="label" [(ngModel)]="label.IsPrint"
                 binary="true" (click)="setShippingSection(label.IsPrint,'print')"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_misc.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_misc" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[2] && purchaseOrderSections[2].name}}</h5>
                <h5 *ngIf="vendorSections.length>0">{{vendorSections[4] && vendorSections[4].name}}</h5>
                <h5 *ngIf="itemReceiptSections.length>0">{{itemReceiptSections[9] && itemReceiptSections[9].name}}</h5>
                <h5 *ngIf="newBillSections.length>0">{{newBillSections[2] && newBillSections[2].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[2] && vendorCreditSections[2].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[2] && vendorReturnSections[2].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox  #l3 ngDefaultControl (click)="selectedPurchaseRow3(selectedPurchaseCheck3,'view')"
                [(ngModel)]="selectedPurchaseCheck3" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
              *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox  #l3 ngDefaultControl (click)="selectedPurchaseRow3(selectedPurchasePrintCheck3,'print')"
                [(ngModel)]="selectedPurchasePrintCheck3" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr *ngIf="!label.IsHide">
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setMiscSection(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.IsPrint"
                 binary="true"  (click)="setMiscSection(label.IsPrint,'print')"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_section.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_section" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[3] && purchaseOrderSections[3].name}} (Any 5)</h5>
                <h5 *ngIf="billSections.length>0">{{billSections[0] && billSections[0].name}}</h5>
                <h5 *ngIf="itemReceiptSections.length>0">{{itemReceiptSections[2] && itemReceiptSections[2].name}}</h5>
                <h5 *ngIf="newBillSections.length>0">{{newBillSections[3] && newBillSections[3].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[3] && vendorReturnSections[3].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[3] && vendorCreditSections[3].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox  #l4 ngDefaultControl (click)="selectedPurchaseRow4(selectedPurchaseCheck4,'view')"
                [(ngModel)]="selectedPurchaseCheck4" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
              *ngIf="templatePOTemp?.producttype?.name=='Purchase Order'||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox  #l4 ngDefaultControl (click)="selectedPurchaseRow4(selectedPurchasePrintCheck4,'print')"
                [(ngModel)]="selectedPurchasePrintCheck4" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr *ngIf="!label.IsHide">
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="(!label.isMovable || (!label.isChecked && maxNo))" value="val" [(ngModel)]="label.isChecked"
                (onChange)="setSectionSection(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns'  ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="(!label.isMovable || (!label.IsPrint && maxNoPrint))" value="val" [(ngModel)]="label.IsPrint"
                (onChange)="setSectionSection(label.IsPrint,'print')" binary="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_expense.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_expense" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="newBillSections.length>0">{{newBillSections[4] && newBillSections[4].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[10] && vendorCreditSections[10].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox #l5 ngDefaultControl (click)="selectedPurchaseRow11(selectedPurchaseCheck11,'view')"
                [(ngModel)]="selectedPurchaseCheck11" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
              *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' || templatePOTemp?.producttype?.name=='Bill'">
                <p-checkbox  #l4 ngDefaultControl (click)="selectedPurchaseRow11(selectedPurchaseCheck11,'print')"
                [(ngModel)]="selectedPurchasePrintCheck11" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr *ngIf="!label.IsHide">
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setExpenseSection(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' || templatePOTemp?.producttype?.name=='Bill'">
                <p-checkbox name="print" [disabled]="(!label.isMovable || (!label.IsPrint && maxNoPrint))" value="val" [(ngModel)]="label.IsPrint"
                (onChange)="setExpenseSection(label.IsPrint,'print')" binary="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_table.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_table" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[4] && purchaseOrderSections[4].name}}</h5>
                <h5 *ngIf="vendorSections.length>0">{{vendorSections[1] && vendorSections[1].name}}</h5>
                <h5 *ngIf="billSections.length>0">{{billSections[1] && billSections[1].name}}</h5>
                <h5 *ngIf="itemReceiptSections.length>0">{{itemReceiptSections[3] && itemReceiptSections[3].name}}</h5>
                <h5 *ngIf="newBillSections.length>0">{{newBillSections[5] && newBillSections[5].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[4] && vendorReturnSections[4].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[4] && vendorCreditSections[4].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox #l5 ngDefaultControl (click)="selectedPurchaseRow5(selectedPurchaseCheck5,'view')"
                [(ngModel)]="selectedPurchaseCheck5" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
                *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns'  ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox #l5 ngDefaultControl  (click)="selectedPurchaseRow5(selectedPurchasePrintCheck5,'print')"
                [(ngModel)]="selectedPurchasePrintCheck5" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr *ngIf="!label.IsHide">
              <td>{{label.name}} 
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setTableSection(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.IsPrint"
                 (click)="setTableSection(label.IsPrint,'print')" binary="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_footer.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_footer" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[5] && purchaseOrderSections[5].name }}</h5>
                <h5 *ngIf="vendorSections.length>0">{{vendorSections[2] && vendorSections[2].name }}</h5>
                <h5 *ngIf="billSections.length>0">{{billSections[2] && billSections[2].name}}</h5>
                <h5 *ngIf="itemReceiptSections.length>0">{{itemReceiptSections[4] && itemReceiptSections[4].name}}</h5>
                <h5 *ngIf="newBillSections.length>0">{{newBillSections[6] && newBillSections[6].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[5] && vendorReturnSections[5].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[5] && vendorCreditSections[5].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox  #l6 ngDefaultControl (click)="selectedPurchaseRow6(selectedPurchaseCheck6,'view')"
                [(ngModel)]="selectedPurchaseCheck6" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
                *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox  #l6 ngDefaultControl (click)="selectedPurchaseRow6(selectedPurchasePrintCheck6,'print')"
                [(ngModel)]="selectedPurchasePrintCheck6" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr *ngIf="!label.IsHide">
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setFooterSection(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.IsPrint"
                  binary="true"  (click)="setFooterSection(label.IsPrint,'print')"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_message.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_message" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[6] && purchaseOrderSections[6].name}}</h5>
                <h5 *ngIf="billSections.length>0">{{billSections[3] && billSections[3].name}}</h5>
                <h5 *ngIf="itemReceiptSections.length>0">{{itemReceiptSections[5] && itemReceiptSections[5].name}}</h5>
                <h5 *ngIf="newBillSections.length>0">{{newBillSections[7] && newBillSections[7].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[6] && vendorReturnSections[6].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[6] && vendorCreditSections[6].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox  #l7 ngDefaultControl (click)="selectedPurchaseRow7(selectedPurchaseCheck7,'view')"
                [(ngModel)]="selectedPurchaseCheck7" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
                *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox  #l7 ngDefaultControl (click)="selectedPurchaseRow7(selectedPurchasePrintCheck7,'print')"
                [(ngModel)]="selectedPurchasePrintCheck7" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr *ngIf="!label.IsHide">
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setMessageSection(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.IsPrint"
                  binary="true"  (click)="setMessageSection(label.IsPrint,'print')"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_other1.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_other1" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[7] && purchaseOrderSections[7].name}} (Any 5)</h5>
                <h5 *ngIf="vendorSections.length>0">{{vendorSections[5] && vendorSections[5].name}}</h5>
                <h5 *ngIf="billSections.length>0">{{billSections[4] && billSections[4].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[7] && vendorReturnSections[7].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[7] && vendorCreditSections[7].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox #l8 ngDefaultControl (click)="selectedPurchaseRow8(selectedPurchaseCheck8,'view')"
                [(ngModel)]="selectedPurchaseCheck8" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
                *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox #l8 ngDefaultControl (click)="selectedPurchaseRow8(selectedPurchasePrintCheck8,'print')"
                [(ngModel)]="selectedPurchasePrintCheck8" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr>
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display"[disabled]="(!label.isMovable || (!label.isChecked && maxNo1))" value="val" [(ngModel)]="label.isChecked"
                (click)="setOther1Section(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="(!label.isMovable || (!label.IsPrint && maxNoPrint1))" value="val" [(ngModel)]="label.IsPrint"
                  binary="true"  (click)="setOther1Section(label.IsPrint,'print')"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_other2.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_other2" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[8] && purchaseOrderSections[8].name}}</h5>
                <h5 *ngIf="vendorSections.length>0">{{vendorSections[6] && vendorSections[6].name}}</h5>
                <h5 *ngIf="billSections.length>0">{{billSections[5] && billSections[5].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[8] && vendorReturnSections[8].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[8] && vendorCreditSections[8].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox #l8 ngDefaultControl (click)="selectedPurchaseRow9(selectedPurchaseCheck9,'view')"
                [(ngModel)]="selectedPurchaseCheck9" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
                *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox #l8 ngDefaultControl (click)="selectedPurchaseRow9(selectedPurchasePrintCheck9,'print')"
                [(ngModel)]="selectedPurchasePrintCheck9" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr>
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setOther2Section(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.IsPrint"
                 binary="true"  (click)="setOther2Section(label.IsPrint,'print')"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="p-grid" *ngIf="availablePurchaseLabels_other3.length>0">
      <div class="p-col-12 p-pl-0">
        <p-table [value]="availablePurchaseLabels_other3" dataKey="id" class="editable">
          <ng-template pTemplate="header">
            <tr>
              <th class="header p-col-4">
                <h5 *ngIf="purchaseOrderSections.length>0">{{purchaseOrderSections[9] && purchaseOrderSections[9].name}}</h5>
                <h5 *ngIf="vendorSections.length>0">{{vendorSections[7] && vendorSections[7].name}}</h5>
                <h5 *ngIf="billSections.length>0">{{billSections[6] && billSections[6].name}}</h5>
                <h5 *ngIf="vendorReturnSections.length>0">{{vendorReturnSections[9] && vendorReturnSections[9].name}}</h5>
                <h5 *ngIf="templatePOTemp?.producttype?.name=='Vendor Credit' && vendorCreditSections.length>0">{{vendorCreditSections[9] && vendorCreditSections[9].name}}</h5>
              </th>
              <th class="header p-col-5"></th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header">
                <p-checkbox #l8 ngDefaultControl (click)="selectedPurchaseRow10(selectedPurchaseCheck10,'view')"
                [(ngModel)]="selectedPurchaseCheck10" binary="true"></p-checkbox>
              </th>
              <th style="width: 100px;padding-top: 0.45rem !important;" class="p-text-center header"
                *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox #l8 ngDefaultControl (click)="selectedPurchaseRow10(selectedPurchasePrintCheck10,'print')"
                [(ngModel)]="selectedPurchasePrintCheck10" binary="true"></p-checkbox>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-label>
            <tr>
              <td>{{label.name}}
                <span style="color: red;" *ngIf="label.isMovable == false">*</span>
              </td>
              <td pEditableColumn class="template">
                <input pInputText type="text" [(ngModel)]="label.labelname">
              </td>
              <td class="p-text-center template">
                <p-checkbox name="display" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.isChecked"
                (click)="setOther3Section(label.isChecked,'view')" binary="true"></p-checkbox>
              </td>
              <td class="p-text-center template" *ngIf="templatePOTemp?.producttype?.name=='Purchase Order' ||  templatePOTemp?.producttype?.name=='Bill' ||  templatePOTemp?.producttype?.name=='Vendor Returns' ||  templatePOTemp?.producttype?.name=='Bill Payment' || templatePOTemp?.producttype?.name=='Vendor Credit'">
                <p-checkbox name="print" [disabled]="!label.isMovable" value="val" [(ngModel)]="label.IsPrint"
                  binary="true"  (click)="setOther3Section(label.isChecked,'print')"></p-checkbox>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
  <p-footer>
    <button type="button" pButton (click)="displayEditPOTemplate1=false" label="Cancel"
      class="p-button-secondary"></button>
    <button type="button" pButton label="Save" (click)="updatePOTemplate(templatePOTemp)"></button>
  </p-footer>
</p-dialog>
